import { Component, OnInit,Input,OnDestroy, ChangeDetectorRef, AfterContentChecked  } from '@angular/core';
import {LoaderService} from './loader.service';
import { Subscription } from 'rxjs';
import {LoaderState} from './LoaderState';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html'
})
export class LoaderComponent implements OnInit,OnDestroy  {


  
@Input() isShowloader:boolean;
loading: boolean;
isresourcesLoaded:boolean=false;
show = false;
private subscription: Subscription;
  constructor(private loaderService: LoaderService) { 


    // this.loaderService.isLoading.subscribe((v) => {
    //   console.log(v);
    //  // this.isShowloader = v;
    //   this.loading=true;
    // });
  }

  ngOnInit(): void {
    this.subscription = this.loaderService.loaderState
    .subscribe((state: LoaderState) => {
      this.show = state.show;
    });
   
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
 

}
